
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class HeroSection extends Vue {
  @Prop({ default: 0 }) readonly currentSectionIndex!: number;
  @Prop({ default: null }) readonly dissolvingNextCtaIndex!: number | null;
  @Prop({ default: false }) readonly useDarkHeroDecorator!: boolean;
  @Prop({ default: false }) readonly heroNextCtaVisible!: boolean;
  @Prop({ default: null }) readonly launchingNextCtaIndex!: number | null;
}
